import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingAction,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const DIALOG_TYPE = 'missing-client-email';

@Component({
  selector: 'app-missing-client-email-dialog',
  templateUrl: './missing-client-email-dialog.component.html',
  styleUrls: ['./missing-client-email-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissingClientEmailDialogComponent implements OnInit {
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onAddClientEmail: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  onDisableBankTransfer: EventEmitter<void> = new EventEmitter<void>();

  dialogType: string;
  trackingDialogName: TrackingDialogNamesEnum;
  primaryActionTrackingAction: ITrackingAction;
  secondaryActionTrackingAction: ITrackingAction;

  constructor(private _trackingActionBuilder: I2gNgTrackingActionBuilder) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingDialogName = TrackingDialogNamesEnum.bank_transfer_add_client;
    this.primaryActionTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'bank_transfer_update_client',
      this.trackingScreenName
    );
    this.secondaryActionTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'turn_off_bank_transfer',
      this.trackingScreenName
    );
  }

  onPrimaryAction() {
    this.onAddClientEmail.emit();
  }

  onSecondaryAction() {
    this.onDisableBankTransfer.emit();
  }
}
